import { createSelector } from 'reselect';
import {
    get,
    isEqual
} from 'lodash';
import {
    KPI_MONTHLY_CHARGEBACK_COUNT_LOAD,
    KPI_MONTHLY_CHARGEBACK_COUNT_SUCCESS,
    KPI_MONTHLY_CHARGEBACK_COUNT_FAILURE,
    KPI_TRANSACTION_SUMMARY_LOAD,
    KPI_TRANSACTION_SUMMARY_SUCCESS,
    KPI_TRANSACTION_SUMMARY_FAILURE
} from './kpiActions';
import { getEntityByName } from '../../appEntities';

const initialState = {
    transactionSummary: {
        summary: {},
        loading: true,
        error: ''
    },
    monthlyChargebackCount: {
        loading: true,
        error: ''
    }
};

export default function reducer(state = initialState, action = {}) {
    let newState;

    switch (action.type) {
        case KPI_MONTHLY_CHARGEBACK_COUNT_LOAD:
            newState = {
                ...state,
                monthlyChargebackCount: initialState.monthlyChargebackCount
            };

            return isEqual(state, newState) ? state : newState;

        case KPI_MONTHLY_CHARGEBACK_COUNT_SUCCESS:
            newState = {
                ...state,
                monthlyChargebackCount: {
                    mtdCount: get(action, 'monthlyChargebackCount.mtdCount'),
                    previousMonthCount: get(action, 'monthlyChargebackCount.previousMonthCount'),
                    loading: false,
                    error: ''
                }
            };

            return isEqual(state, newState) ? state : newState;

        case KPI_MONTHLY_CHARGEBACK_COUNT_FAILURE:
            newState = {
                ...state,
                monthlyChargebackCount: {
                    error: action.error,
                    loading: false,
                    mtdCount: undefined,
                    previousMonthCount: undefined
                }
            };

            return isEqual(state, newState) ? state : newState;

        case KPI_TRANSACTION_SUMMARY_LOAD:
            newState = {
                ...state,
                transactionSummary: initialState.transactionSummary
            };

            return isEqual(state, newState) ? state : newState;

        case KPI_TRANSACTION_SUMMARY_SUCCESS:
            newState = {
                ...state,
                transactionSummary: {
                    summary: action.summary,
                    loading: false,
                    error: ''
                }
            };

            return isEqual(state, newState) ? state : newState;

        case KPI_TRANSACTION_SUMMARY_FAILURE:
            newState = {
                ...state,
                transactionSummary: {
                    error: action.error,
                    loading: false,
                    summary: {}
                }
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getKpiEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'resellerKpi')
);

export const getMonthlyChargebackCountObject = createSelector(
    getKpiEntity,
    (entity) => get(entity, 'monthlyChargebackCount')
);

export const getIsMonthlyChargebackCountLoading = createSelector(
    getMonthlyChargebackCountObject,
    (entity) => get(entity, 'loading')
);

export const getMonthlyChargebackCountMtdCount = createSelector(
    getMonthlyChargebackCountObject,
    (entity) => get(entity, 'mtdCount')
);

export const getMonthlyChargebackCountPreviousMonthCount = createSelector(
    getMonthlyChargebackCountObject,
    (entity) => get(entity, 'previousMonthCount')
);

export const getMonthlyChargebackCountError = createSelector(
    getMonthlyChargebackCountObject,
    (entity) => get(entity, 'error')
);

export const getMonthlyChargebackCountErrorMessage = createSelector(
    getMonthlyChargebackCountError,
    (entity) => get(entity, 'message')
);

export const getTransactionSummaryObject = createSelector(
    getKpiEntity,
    (entity) => get(entity, 'transactionSummary')
);

export const getTransactionSummary = createSelector(
    getTransactionSummaryObject,
    (summaryObject) => get(summaryObject, 'summary')
);

export const getTransactionSummaryIsLoading = createSelector(
    getTransactionSummaryObject,
    (summaryObject) => get(summaryObject, 'loading')
);

export const getTransactionSummaryError = createSelector(
    getTransactionSummaryObject,
    (summaryObject) => get(summaryObject, 'error')
);

export const getTransactionSummaryErrorMessage = createSelector(
    getTransactionSummaryError,
    (error) => get(error, 'message')
);
